module.exports = __webpack_public_path__ + "fonts/TTNormsPro-BlackItalic.944dae2f.ttf";